import {
  ClassSchedule,
  ExamSessionDetails,
} from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import React, { CSSProperties, useState } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ClassProtectors } from './componenets/class-protectors';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { AddNewProtectors } from '../../componenets/add-new-protector-dialog/add-new-protectors';
import { Dialog } from 'primereact/dialog';
import '../../../../expandabe-table-view-icon-rtl.css';

interface ExamPageProtectorsTabDatamodel {
  examId: number;
  sessionId: number;
  classesSchedule?: ClassSchedule[];
  setSessionDetails: (sessions: ExamSessionDetails[]) => any;
}

const columnStyle: CSSProperties = {
  textAlign: 'right',
  minWidth: '100px',
  maxWidth: '100px',
};

export const ExamPageProtectorsTab: React.FC<
  ExamPageProtectorsTabDatamodel
> = ({ classesSchedule, examId, sessionId, setSessionDetails }) => {
  const [expandedRows, setExpandedRows] = useState<ClassSchedule[]>([]);
  const [addProtectorIndex, setAddProtectorIndex] = useState<number | null>(
    null,
  );

  const forbiddenProtectorsIds: number[] =
    classesSchedule?.flatMap((item) =>
      item.protectors.map((protectorItem) => protectorItem.id),
    ) ?? [];

  // Check if a row is expanded
  const isRowExpanded = (rowData: ClassSchedule) => {
    return expandedRows.some((row) => row.classId === rowData.classId);
  };

  // Toggle row expansion
  const toggleRowExpansion = (rowData: ClassSchedule) => {
    const isExpanded = isRowExpanded(rowData);

    let newExpandedRows: ClassSchedule[];
    if (isExpanded) {
      // Collapse - remove from expanded rows
      newExpandedRows = expandedRows.filter(
        (row) => row.classId !== rowData.classId,
      );
    } else {
      // Expand - add to expanded rows
      newExpandedRows = [...expandedRows, rowData];
    }

    setExpandedRows(newExpandedRows);
  };

  // Custom expander template
  const expanderTemplate = (rowData: ClassSchedule) => {
    const isExpanded = isRowExpanded(rowData);
    return (
      <Button
        icon={isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'}
        onClick={(e) => {
          e.stopPropagation();
          toggleRowExpansion(rowData);
        }}
        text
        rounded
        severity="secondary"
      />
    );
  };

  return (
    <div>
      <Dialog
        header="הוספת משגיח"
        visible={addProtectorIndex !== null}
        style={{
          height: '70vh',
          width: '80vw',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => setAddProtectorIndex(null)}
      >
        {addProtectorIndex !== null &&
          classesSchedule &&
          classesSchedule[addProtectorIndex] && (
            <AddNewProtectors
              examId={examId}
              sessionId={sessionId}
              classId={classesSchedule[addProtectorIndex].classId}
              setExamDetails={setSessionDetails}
              onHide={() => setAddProtectorIndex(null)}
              forbiddenProtectorIds={forbiddenProtectorsIds}
            />
          )}
      </Dialog>

      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        value={classesSchedule ?? []}
        scrollable
        dataKey="classId"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
        expandedRows={expandedRows}
        rowExpansionTemplate={(rowData) => (
          <div
            style={{
              borderTop: '1px solid #06b6d4',
            }}
          >
            <ClassProtectors
              protectors={rowData.protectors}
              examId={examId}
              sessionId={sessionId}
              classesSchedule={rowData}
              setSessionDetails={setSessionDetails}
            />
          </div>
        )}
      >
        <Column
          body={expanderTemplate}
          style={{ width: '3rem', textAlign: 'center' }}
        />

        <Column
          header="שם"
          field={'className'}
          style={{ ...columnStyle, fontWeight: 'bold' }}
        />

        <Column
          header="ת.ז"
          field={'className'}
          style={columnStyle}
          body={() => <div></div>}
        />

        <Column
          header="סוג פעילות"
          field={'className'}
          style={columnStyle}
          body={() => <div></div>}
        />

        <Column
          header="שעת התחלה"
          field={'startAt'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => <label></label>}
        />

        <Column
          header="שעת סיום"
          field={'endAt'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => <label></label>}
        />

        <Column
          header=""
          style={columnStyle}
          body={(rowData: ClassSchedule, options) => (
            <div>
              <Tooltip target=".my-button" position="right">
                הוסף משגיח לבחינה
              </Tooltip>
              <Button
                icon="pi pi-plus"
                aria-label="Filter"
                className="my-button"
                onClick={() => setAddProtectorIndex(options.rowIndex)}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
};
